/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, { useEffect } from 'react'
import styled from "styled-components";
import Table from './Table'
import { sensorUltrasonicHeaderTitle } from "./constants";

const Container = styled.div({
  display: 'flex',
  flexFlow: 'column',
  overflow: 'auto',
  height: '100%'
})

function SensorUltrasonic() {
  useEffect(() => {
    document.title = sensorUltrasonicHeaderTitle + ' - Landing';
    return () => {
      document.title = 'Argos';
    };
  }, []);
  return (
    <Container>
      <Table/>
    </Container>
  )
}

export default SensorUltrasonic;